import { render, staticRenderFns } from "./LibHeader.vue?vue&type=template&id=36846f1f&scoped=true"
import script from "./LibHeader.vue?vue&type=script&lang=js"
export * from "./LibHeader.vue?vue&type=script&lang=js"
import style0 from "./LibHeader.vue?vue&type=style&index=0&id=36846f1f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36846f1f",
  null
  
)

export default component.exports